export var BlendFactor;
(function (BlendFactor) {
    BlendFactor[BlendFactor["Zero"] = 0] = "Zero";
    BlendFactor[BlendFactor["One"] = 1] = "One";
    BlendFactor[BlendFactor["SourceColor"] = 2] = "SourceColor";
    BlendFactor[BlendFactor["OneMinusSourceColor"] = 3] = "OneMinusSourceColor";
    BlendFactor[BlendFactor["DestinationColor"] = 4] = "DestinationColor";
    BlendFactor[BlendFactor["OneMinusDestinationColor"] = 5] = "OneMinusDestinationColor";
    BlendFactor[BlendFactor["SourceAlpha"] = 6] = "SourceAlpha";
    BlendFactor[BlendFactor["OneMinusSourceAlpha"] = 7] = "OneMinusSourceAlpha";
    BlendFactor[BlendFactor["DestinationAlpha"] = 8] = "DestinationAlpha";
    BlendFactor[BlendFactor["OneMinusDestinationAlpha"] = 9] = "OneMinusDestinationAlpha";
    BlendFactor[BlendFactor["SourceAlphaSaturate"] = 10] = "SourceAlphaSaturate";
    BlendFactor[BlendFactor["BlendColor"] = 11] = "BlendColor";
    BlendFactor[BlendFactor["OneMinusBlendColor"] = 12] = "OneMinusBlendColor";
})(BlendFactor || (BlendFactor = {}));
